import { FC, Fragment, memo, useState } from 'react'
import { Divider, FormControlLabel, FormHelperText, Radio, RadioGroup } from '@maas-components/core'
import { EVariationTypes, OTHER_VARIATION_TYPES_LIST } from 'core/common/constants/multivariation'
import i18n from 'core/common/i18n'
import Modal from 'core/components/Modal'
import { PaperStyled } from './styles'

export type TModalProps = {
  open: boolean
  onClose: () => void
  onSubmit: (value: EVariationTypes | null) => void
  disabledItems?: EVariationTypes[]
}

const OtherVariationsModal: FC<TModalProps> = ({ open, onClose, disabledItems = [], onSubmit }) => {
  const [selectedValue, setSelectedValue] = useState<EVariationTypes | null>(null)

  const handleConfirm = () => {
    onSubmit(selectedValue)
  }

  return (
    <Modal
      open={open}
      onAbort={onClose}
      onCancel={onClose}
      title={i18n.t('multivariation.variationType.otherVariationsTitle')}
      PropsConfirm={{ disabled: !selectedValue, 'data-testid': 'button-confirm' }}
      onConfirm={handleConfirm}
      textConfirm={i18n.t('general.select')}
      PropsContent={{
        className: 'p-0 w-100',
      }}
      maxWidth="md"
      fullWidth
      PaperComponent={PaperStyled}
    >
      <RadioGroup
        value={selectedValue}
        onChange={({ target }) => setSelectedValue(target.value as EVariationTypes)}
      >
        {OTHER_VARIATION_TYPES_LIST.map(({ value, label, helperText }) => (
          <Fragment key={value}>
            <FormControlLabel
              className="d-flex justify-between m-0 px-4 py-2"
              data-testid={`form-control-label-${value}`}
              control={<Radio />}
              label={
                <>
                  {label}
                  <FormHelperText className="mt-1">{helperText}</FormHelperText>
                </>
              }
              disabled={disabledItems.includes(value)}
              value={value}
              labelPlacement="start"
            />
            <Divider />
          </Fragment>
        ))}
      </RadioGroup>
    </Modal>
  )
}

export default memo(OtherVariationsModal)
